export enum ETaskAction {
  ACTION_CREATE,
  ACTION_UPDATE,
  ACTION_DELETE,
  ACTION_SHARE,
  ACTION_DISCARD,
  ACTION_UPDATE_TEMPLATE,
  ACTION_TASK_LOADED,
}
